/**
 * Authentication Service Module
 *
 * Exports the AuthService singleton for authentication operations.
 */

import { supabase } from '@/services/database/client';
import { useAuthStore } from '@/stores/authStore';
import { createAuthStoreAdapter } from '@/services/adapters/store.adapters';
import { AuthService } from './auth.service';

/**
 * Singleton AuthService instance
 * Initialized with Supabase client and auth store adapter
 */
export const authService = new AuthService(supabase, createAuthStoreAdapter(useAuthStore));

/**
 * Export class for testing (can mock dependencies)
 */
export { AuthService };
